<template>
  <div>
    <div class="table-responsive col-lg-12">
      <table class="table table-striped table-bordered table-hover">
        <thead>
        <tr>
          <th>Name</th>
          <th>Clients</th>
          <th>Integration</th>
          <th># Domains</th>
          <th>Last import</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(registrar, i) in registrars" v-show="registrar.show" :key="registrar.id + i">
          <td>
            <router-link :to="'/account/registrar/' + registrar.id" v-if="registrar.id">{{ registrar.name || '/' }}</router-link>
            <router-link :to="'/account/registrar/unassigned-' + registrar.client.id" v-else>{{ registrar.name || '/' }}</router-link>
          </td>
          <td>{{ registrar.client | getName }}</td>
          <td>
            <span v-if="registrar.integration">
              <i class="fa fa-warning red" v-if="registrar.failed" v-tooltip="'Import failed!'"></i>
              <i class="fa fa-check green" v-else v-tooltip="'All good'"></i>
            </span>
            {{ registrar.integration | getName }}
          </td>
          <td>{{ registrar.domainCount }}</td>
          <td>{{ registrar.import | aTime('from') }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  computed: {
    ...mapGetters({
      registrars: 'getRegistrars'
    })
  },
  filters: {
    fromNow: ts => ts && ts.date ? moment(ts.date).fromNow() : '',
    getName: client => client ? client.name : ''
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Accounts/Registrars/List.vue